var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompleted(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 33,
    viewBox: "0 0 25 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6701_505237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9927 6.26562H9.00779C8.56939 6.26562 8.21387 6.62115 8.21387 7.05955V9.81299H16.7867V7.05955C16.7867 6.62115 16.4311 6.26562 15.9927 6.26562ZM15.9737 9.36963H9.02683V7.58818C9.02683 7.26594 9.28811 7.00466 9.61035 7.00466H15.3902C15.7124 7.00466 15.9737 7.26594 15.9737 7.58818V9.36963Z",
    fill: "#979797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5003 32.0591C19.0307 32.0591 24.3247 26.7651 24.3247 20.2346C24.3247 13.7042 19.0307 8.41016 12.5003 8.41016C5.96978 8.41016 0.675781 13.7042 0.675781 20.2346C0.675781 26.7651 5.96978 32.0591 12.5003 32.0591Z",
    fill: "#979797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5003 31.6138C18.7859 31.6138 23.8814 26.5183 23.8814 20.2327C23.8814 13.9471 18.7859 8.85156 12.5003 8.85156C6.21464 8.85156 1.11914 13.9471 1.11914 20.2327C1.11914 26.5183 6.21464 31.6138 12.5003 31.6138Z",
    fill: "url(#paint0_linear_6701_505237)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5003 31.6138C18.7859 31.6138 23.8814 26.5183 23.8814 20.2327C23.8814 13.9471 18.7859 8.85156 12.5003 8.85156C6.21464 8.85156 1.11914 13.9471 1.11914 20.2327C1.11914 26.5183 6.21464 31.6138 12.5003 31.6138Z",
    fill: "url(#paint1_linear_6701_505237)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5007 28.2904C16.9495 28.2904 20.556 24.6839 20.556 20.235C20.556 15.7862 16.9495 12.1797 12.5007 12.1797C8.05182 12.1797 4.44531 15.7862 4.44531 20.235C4.44531 24.6839 8.05182 28.2904 12.5007 28.2904Z",
    fill: "url(#paint2_linear_6701_505237)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4999 27.1053C16.2957 27.1053 19.3729 24.0282 19.3729 20.2323C19.3729 16.4365 16.2957 13.3594 12.4999 13.3594C8.70408 13.3594 5.62695 16.4365 5.62695 20.2323C5.62695 24.0282 8.70408 27.1053 12.4999 27.1053Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9391 0.0585938H10.0615V7.00547H14.9391V0.0585938Z",
    fill: "#F8F3EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6874 0.0585938H10.0615V7.00547H11.6874V0.0585938Z",
    fill: "#F82C23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9394 0.0585938H13.3135V7.00547H14.9394V0.0585938Z",
    fill: "#2671F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.184 19.4693C16.028 19.2453 15.752 19.1173 15.436 19.1173H13.796C13.688 19.1173 13.588 19.0733 13.52 18.9933C13.448 18.9133 13.42 18.8013 13.436 18.6853L13.64 17.3733C13.728 16.9813 13.468 16.5413 13.076 16.4093C12.712 16.2733 12.284 16.4573 12.112 16.7173L10.424 19.2253L10.376 19.3053V22.8413L10.436 22.9013L11.704 23.8813C11.872 24.0493 12.252 24.1413 12.52 24.1413H14.08C14.616 24.1413 15.156 23.7373 15.276 23.2453L16.26 20.2493C16.364 19.9653 16.336 19.6893 16.184 19.4693Z",
    fill: "#979797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.60822 18.0078H9.19622C8.57622 18.0078 8.32422 18.2478 8.32422 18.8398V22.8638C8.32422 23.4558 8.57622 23.6958 9.19622 23.6958H9.60822C10.2282 23.6958 10.4802 23.4558 10.4802 22.8638V18.8398C10.4802 18.2478 10.2282 18.0078 9.60822 18.0078Z",
    fill: "#2C3335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6701_505237",
    x1: 1.1192,
    y1: 20.2327,
    x2: 23.8813,
    y2: 20.2327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7A44B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5636,
    stopColor: "#EBB370"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0B265"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6701_505237",
    x1: 12.5003,
    y1: 8.85156,
    x2: 12.5003,
    y2: 31.6138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E0E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6701_505237",
    x1: 12.5007,
    y1: 12.1797,
    x2: 12.325,
    y2: 30.2594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#979797",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6701_505237"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.649,
    height: 32,
    fill: "white",
    transform: "translate(0.675781 0.0585938)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted);
export default __webpack_public_path__ + "static/media/completed.b7c5ce852857fd12af9f97da5991f139.svg";
export { ForwardRef as ReactComponent };